var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.614 5.143l-6.9 12h5.331l6.729-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5BF",
    d: "m16.77 5.143l-12.056 12h5.331l6.729-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AA800",
    d: "M11.687 17.143h6.741l-3.364-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7FDF00",
    d: "M15.771 17.143h2.657l-3.364-6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLever);
export default __webpack_public_path__ + "static/media/lever.adf54b14491351f86531eec9cdf1e61e.svg";
export { ForwardRef as ReactComponent };